/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeTenantDto,
  CreateMyTenantRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type tenantCreateCreateTenantResponse200 = {
  data: ApiEnvelopeTenantDto
  status: 200
}

export type tenantCreateCreateTenantResponse400 = {
  data: ApiEnvelopeTenantDto
  status: 400
}

export type tenantCreateCreateTenantResponse401 = {
  data: ApiEnvelopeTenantDto
  status: 401
}

export type tenantCreateCreateTenantResponseSuccess = (tenantCreateCreateTenantResponse200) & {
  headers: Headers;
};
export type tenantCreateCreateTenantResponseError = (tenantCreateCreateTenantResponse400 | tenantCreateCreateTenantResponse401) & {
  headers: Headers;
};

export type tenantCreateCreateTenantResponse = (tenantCreateCreateTenantResponseSuccess | tenantCreateCreateTenantResponseError)

export const getTenantCreateCreateTenantUrl = () => {




  return `/api/tenants`
}

export const useTenantCreateCreateTenantHook = (): (createMyTenantRequest?: CreateMyTenantRequest, options?: RequestInit) => Promise<tenantCreateCreateTenantResponse> => {

      const customFetcher = useSfetchMutator();
      return (createMyTenantRequest?: CreateMyTenantRequest, options?: RequestInit) => {

        return customFetcher(getTenantCreateCreateTenantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMyTenantRequest)
  }
);
      }
  }


